import { BaseEvent } from '../../../../../domain/event/base-event';
export class PhotoEvent extends BaseEvent {
    constructor({ subject, type, payload, metadata, fromPersistence, }) {
        metadata = {
            aggregatename: 'Photo',
            ...metadata,
        };
        super({
            subject,
            type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
//# sourceMappingURL=photo.event.js.map